import styled from "styled-components";
export const StackWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
  &:hover {
    transform: perspective(800px) rotateY(4deg);
  }
`;
export const ContentWrapper = styled.div`
  position: relative;
  aspect-ratio: 16/9;
  &::before {
    content: "";
    width: 101%;
    height: 101%;
    display: inline-block;
    background: linear-gradient(
      to right bottom,
      rgb(54 203 20),
      rgb(26 133 205)
    );
    position: absolute;
    box-shadow: inset 0 1px 1px 0 hsla(0, 0%, 100%, 0.15),
      0 50px 100px -20px rgba(50, 50, 93, 0.3),
      0 30px 60px -30px rgba(0, 0, 0, 0.5),
      -10px 10px 60px -10px rgba(103, 178, 111, 0.3);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    transform: rotate(4deg) translatez(-40px);
    transform-origin: 20% 70%;
  }
`;
const image = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  display: inline-block;
  border: 2px solid green;
  aspect-ratio: 16/9;
  border-radius: 8px;

  &:nth-child(1) {
    transform: translateY(10px) scaleX(1);
    z-index: 3;
  }
  &:nth-child(2) {
    transform: translateY(20px) scaleX(0.95);
    z-index: 2;
  }
  &:nth-child(3) {
    transform: translateY(30px) scaleX(0.9);
    z-index: 1;
    box-shadow: inset 0 1px 1px 0 hsla(0, 0%, 100%, 0.15),
      0 50px 100px -20px rgba(50, 50, 93, 0.3),
      0 30px 60px -30px rgba(0, 0, 0, 0.5),
      -10px 10px 60px -10px rgba(103, 178, 111, 0.3);
  }
`;
export const DefaultImg = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  display: inline-block;
  border: 2px solid green;
  border-radius: 8px;
  box-shadow: 0 10px 6px -6px #777;
  transform: scaleX(0.9) skew(10deg);
  transition: all 0.5s;
  &:hover {
    transform: perspective(800px) translateY(-50%) rotateY(4deg);
  }
`;
export const RotateImg = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 50%;
  display: inline-block;
  border: 2px solid green;
  aspect-ratio: 16/9;
  border-radius: 8px;
  transform: rotate(0deg) translateY(-50%);
  transition: all 0.5s;
  &:hover {
    transform: perspective(800px) translateY(-50%) rotateY(4deg);
  }
`;
export const PopImg = styled.img`
position: absolute;
right: 0;
bottom: 0;
left: 0;
top: 0;
display: inline-block;
border: 2px solid green;
border-radius: 8px;
box-shadow: 0 10px 6px -6px #777;
// transform:
// perspective(800px)
// rotateY(25deg) scale(0.9)
// rotateX(10deg);
// filter: blur(2px);
// opacity: 0.5;
// transition: 0.6s ease all;
// &:hover {
//   transform:
//     perspective(800px)
//     rotateY(-15deg)
//     translateY(-50px)
//     rotateX(10deg)
//     scale(1);
//   filter: blur(0);
//   opacity: 1;
// }
transform:
perspective(900px)
rotateX(60deg)
scale(0.7);
box-shadow: 0px 20px 100px #555;
transition:0.5s ease all;

&:hover {
transform:
  rotate(0deg)
  scale(1)
  translateY(10px);
`;
export const GroupImg = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  display: inline-block;
  border: 2px solid green;
  border-radius: 8px;
  box-shadow: 0 10px 6px -6px #777;
  &:nth-child(1) {
    transform: scale(0.75) rotateY(-30deg) rotateX(45deg) translateZ(4.5rem);
    transform-origin: 50% 100%;
    transform-style: preserve-3d;
    box-shadow: 1rem 1rem 2rem rgba(0, 0, 0, 0.25);
    transition: 0.6s ease transform;
    &:hover {
      transform: scale(1);
    }

    &::before {
      transform: translateZ(4rem);
      &:hover {
        transform: translateZ(0);
      }
    }

    &::after {
      transform: translateZ(-4rem);
      &:hover {
        transform: translateZ(-1px);
      }
    }
  }
  &:nth-child(2) {
    transform: scale(0.75) rotateY(-30deg) rotateX(45deg) translateZ(4.5rem);
    transform-origin: 50% 100%;
    transform-style: preserve-3d;
    box-shadow: 1rem 1rem 2rem rgba(0, 0, 0, 0.25);
    transition: 0.6s ease transform;
    &:hover {
      transform: scale(1);
    }

    &::before {
      transform: translateZ(4rem);
      &:hover {
        transform: translateZ(0);
      }
    }

    &::after {
      transform: translateZ(-4rem);
      &:hover {
        transform: translateZ(-1px);
      }
    }
  }
  &:nth-child(3) {
    transform: scale(0.75) rotateY(-30deg) rotateX(45deg) translateZ(4.5rem);
    transform-origin: 50% 100%;
    transform-style: preserve-3d;
    box-shadow: 1rem 1rem 2rem rgba(0, 0, 0, 0.25);
    transition: 0.6s ease transform;
    &:hover {
      transform: scale(1);
    }

    &::before {
      transform: translateZ(4rem);
      &:hover {
        transform: translateZ(0);
      }
    }

    &::after {
      transform: translateZ(-4rem);
      &:hover {
        transform: translateZ(-1px);
      }
    }
  }
`;

export default image;
